import {Injectable} from '@angular/core';

import {ConstantsService} from '../../../../services/constants.service';
import {UserRole} from '../../../../types/admin-data.types';
import {ApiClientService} from '../../../../services/api-client.service';
import {UrlService} from '../../../../services/url.service';
import {EmptyRowService} from '../../../../services/empty-row.service';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {AccountPermissionsService} from '../../../../services/account-permissions.service';
import {tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from '../../../../services/helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class UserRoleService {
    spinnerShow = false;
    corporationNumberList = [];
    data: UserRole[] = [];
    total: number | null = null;
    showAmenityPermissionsTable = false;
    buildings = [];

    constructor(public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                public account: AccountPermissionsService) {
        this.account.onPermissionsUpdate.subscribe(() => {
            this.account.navigateIfServiceDisallowed('auth', '/home');
        });
    }

    get(checkedId?: number) {
        this.getByQueryParams(checkedId).subscribe();
    }

    getByQueryParams(checkedId?: number) {
        const queryParams = this.urlService.getQueryParamsString();
        const url = `/api/v1/role.json?${queryParams}`;
        return this.api.getJson('oauthUrl', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(
                    item => {
                        if (item.usersData) {
                            const keys = Object.keys(item.usersData);
                            item.usersData = keys.map(key => (item.usersData[key]));
                        }
                        return new UserRole(item, checkedId === +item.id);
                    }
                ),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    res => {
                        this.data = res.entities;
                        this.total = res.total;
                        this.emptyRowService.fillEmptyRow();
                        if ($('.table')[0])
                            $('.table')[0].scrollIntoView();
                    },
                    error => this.api.errorHandler(error, 'Failed get Roles')
                )
            );
    }

    getCorporationNumber() {
        this.corporationNumberList = [];
        const url = `/v1/corporation_number?per-page=10000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.corporationNumberList = body.entities;
            });
    }

    create(data): Observable<any> {
        return this.api.post('oauthUrl', '/api/v1/role.json', data).map((res) => {
            return res;
        }, (error) => {
            this.api.errorHandler(error, 'Create role failed');

            return error;
        });
    }

    update(id: number, data: any) {
        this.spinnerShow = true;
        return this.api.patch('oauthUrl', `/api/v1/role/${id}.json`, data).map((res) => {
            toastr.success('The role has been updated successfully.');
            this.spinnerShow = false;
            this.account.init();
            return res;
        }, (error) => {
            this.spinnerShow = false;
            this.api.errorHandler(error, 'Edit role failed');
        });
    }

    remove(id: number): Observable<any> {
        if (!id) return;

        const subject = new ReplaySubject<any>(null);

        swal(ConstantsService.getSwalConfig('Delete role'),
            () => {
                const url = `/api/v1/role/${id}`;
                this.api.remove('oauthUrl', url).subscribe(
                    (res) => {
                        toastr.success('Role has been deleted.');
                        if (this.data.length - 1 == 0 && this.urlService.queryParams.page != '1')
                            this.urlService.queryParams.page = (parseInt(this.urlService.queryParams.page) - 1).toString();
                        this.account.init();
                        this.get();
                        subject.next(res);
                    },
                    error => this.api.errorHandler(error, 'Delete role failed')
                );
            }
        );

        return subject;
    }

    toggleCheckRole(item: UserRole): boolean {
        const checked = item.checked;
        this.data.forEach(i => i.checked = false);
        if (!checked) {
            item.checked = true;
        }

        return item.checked;
    }

    getAmenityPermissions(id, buildingId?) {
        const building = buildingId ? `&building_id=${buildingId}` : '';
        const url = `/v1/amenity_role_settings.json?page=1&per-page=10000&role_id=${id}${building}`;
        return this.api.get('domainAmenities', url);
    }

    public getBuildings() {
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc`;

        this.api.get('domainBD', url).subscribe(
            (res) => {
                this.buildings = [];
                this.buildings = JSON.parse(res._body).entities;
            },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/services/user-role.service.ts